import * as React from "react";
import Button from "@mui/material/Button";
import { Button as FooterButton } from "react-bootstrap";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { Badge, Grid, IconButton } from "@mui/material";
import { Col } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";
import { GetAllServices } from "../../API/endpoints/Discovery";
import {
  GetCategories,
  GetMarketPresenceCountries,
  GetYearsOfOperation,
} from "../../API/endpoints/Common";
import { EngagementModelDTO, YearsOfOperationDTO } from "../dtos/brand.dtos";
import { GetEngagementModels } from "../../API/endpoints/Brands";
import { Row } from "react-bootstrap";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}
export default function AlertDialog(props: any) {
  const { onFilter, onClearFilter } = props;
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);

  const [marketPresenceCountries, setMarketPresenceCountries] = React.useState(
    []
  );
  const [servicesList, setServicesList] = React.useState<any[]>([]);
  const [engagementModelList, setEngagementModelList] = React.useState<
    EngagementModelDTO[]
  >([]);
  const [categories, setCategories] = React.useState([]);
  const [tenureList, setTenureList] = React.useState<YearsOfOperationDTO[]>([]);

  const [selectedCategories, setSelectedCategories] = React.useState<string[]>(
    []
  );
  const [selectedMarkets, setSelectedMarkets] = React.useState<any[]>([]);
  const [selectedServices, setSelectedServices] = React.useState<string[]>([]);
  const [selectedEngagementModels, setSelectedEngagementModels] =
    React.useState<string[]>([]);
  const [selectedPaymentTerms, setSelectedPaymentTerms] = React.useState<
    string[]
  >([]);
  const [selectedTenure, setSelectedTenure] = React.useState<string[]>([]);
  const [selectedExclusivity, setSelectedExclusivity] = React.useState<
    string[]
  >([]);
  const [selectedInvestment, setSelectedInvestment] = React.useState<string[]>(
    []
  );

  const paymentTermsList: any[] = [
    {
      id: "COD",
      name: "COD",
    },
    {
      id: "Bank LC",
      name: "Bank LC",
    },
    {
      id: "30-60 Days Credit",
      name: "30-60 Days Credit",
    },
    {
      id: "Escrow",
      name: "Escrow",
    },
  ];

  const exclusivityList: any[] = [
    {
      id: "Exclusive",
      name: "Exclusive",
    },
    {
      id: "Non - Exclusive",
      name: "Non - Exclusive",
    },
    {
      id: "Both",
      name: "Both",
    },
  ];

  const investmentsList: any[] = [
    {
      id: "Partner Responsibility",
      name: "Partner Responsibility",
    },
    {
      id: "Brand Responsibility",
      name: "Brand Responsibility",
    },
    {
      id: "Co - Responsibility",
      name: "Co - Responsibility",
    },
  ];

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    (async () => {
      const countries = await GetMarketPresenceCountries();
      setMarketPresenceCountries(countries.data);
    })();

    (async () => {
      try {
        const response = await GetCategories();
        setCategories(
          response.data.map((item: any) => {
            return { ...item, id: item.display_name };
          })
        );
      } catch (error) {}
    })();

    getYearsOfOperation();
    getEngagementModelsList();
    getServicesList();
  }, []);

  const getYearsOfOperation = () => {
    const years = [
      {
        id: 1,
        name: "3 yrs or more",
        display_name: "3 yrs or more",
      },
      {
        id: 1,
        name: "2 yrs",
        display_name: "2 yrs",
      },
      {
        id: 1,
        name: "1 yr",
        display_name: "1 yr",
      },
    ];

    setTenureList(years);
  };

  const getEngagementModelsList = async () => {
    //const response = await GetEngagementModels();
    //if (response) {
    const engagementModels: EngagementModelDTO[] = [
      {
        id: 1,
        name: "pre-purchase",
        display_name: "Pre-Purchase",
      },
      {
        id: 1,
        name: "consignment",
        display_name: "Consignment",
      },
      {
        id: 1,
        name: "both",
        display_name: "Both",
      },
    ];
    setEngagementModelList(engagementModels);
    //}
  };

  const getServicesList = async () => {
    //const response = await GetAllServices();
    //if (response) {
    // const postServices: any[] = response?.data?.post_launch_service;
    // const preServices: any[] = response?.data?.pre_launch_service;
    const services = [
      {
        id: 1,
        name: "regulatory_compliance",
        display_name: "Regulatory Compliance",
      },
      {
        id: 2,
        name: "importation_clearance",
        display_name: "Importation & Clearance",
      },
      {
        id: 3,
        name: "sales",
        display_name: "Sales",
      },
      {
        id: 4,
        name: "marketing",
        display_name: "Marketing",
      },
      {
        id: 5,
        name: "distribution",
        display_name: "Distribution",
      },
      {
        id: 6,
        name: "warehousing",
        display_name: "Warehousing",
      },
    ];
    setServicesList([...services]);
    //}
  };

  const handleOptionClick = (name: any, type: string) => {
    switch (type) {
      case "CATEGORY_FOCUS":
        if (selectedCategories.includes(name)) {
          setSelectedCategories(
            selectedCategories.filter((item: string) => item !== name)
          );
        } else {
          setSelectedCategories((prev) => [...prev, name]);
        }
        break;
      case "MARKETS":
        if (selectedMarkets.indexOf(name) > -1) {
          setSelectedMarkets(
            selectedMarkets.filter((item: any) => item !== name)
          );
        } else {
          setSelectedMarkets((prev) => [...prev, name]);
        }
        break;

      case "SERVICES":
        if (selectedServices.includes(name)) {
          setSelectedServices(
            selectedServices.filter((item: string) => item !== name)
          );
        } else {
          setSelectedServices((prev) => [...prev, name]);
        }
        break;

      case "ENGAGEMENT_MODELS":
        if (selectedEngagementModels.includes(name)) {
          setSelectedEngagementModels(
            selectedEngagementModels.filter((item: string) => item !== name)
          );
        } else {
          setSelectedEngagementModels((prev) => [...prev, name]);
        }
        break;

      case "PAYMENT_TERMS":
        if (selectedPaymentTerms.includes(name)) {
          setSelectedPaymentTerms(
            selectedPaymentTerms.filter((item: string) => item !== name)
          );
        } else {
          setSelectedPaymentTerms((prev) => [...prev, name]);
        }
        break;

      case "TENURE":
        if (selectedTenure.includes(name)) {
          setSelectedTenure(
            selectedTenure.filter((item: string) => item !== name)
          );
        } else {
          setSelectedTenure((prev) => [...prev, name]);
        }
        break;
      case "EXCLUSIVITY":
        if (selectedExclusivity.includes(name)) {
          setSelectedExclusivity(
            selectedExclusivity.filter((item: string) => item !== name)
          );
        } else {
          setSelectedExclusivity((prev) => [...prev, name]);
        }
        break;
      case "TRADE_MARKETING":
        if (selectedInvestment.includes(name)) {
          setSelectedInvestment(
            selectedInvestment.filter((item: string) => item !== name)
          );
        } else {
          setSelectedInvestment((prev) => [...prev, name]);
        }
        break;
      default:
        break;
    }
  };

  const handleFilter = () => {
    const req: any = {
      service_capabilities: selectedServices,
      category_focus: selectedCategories,
      region: selectedMarkets.length > 0 ? selectedMarkets : undefined,
      trading_terms: selectedExclusivity,
      minimum_tenure: selectedTenure ? selectedTenure : undefined,
      engagement_model: selectedEngagementModels,
      payment_terms: selectedPaymentTerms,
      trade_marketing_investments: selectedInvestment
        ? selectedInvestment
        : undefined,
    };

    onFilter(req);
    handleClose();
  };

  const handleClearFilter = () => {
    setSelectedCategories([]);
    setSelectedMarkets([]);
    setSelectedServices([]);
    setSelectedEngagementModels([]);
    setSelectedPaymentTerms([]);
    setSelectedTenure([]);
    setSelectedExclusivity([]);
    setSelectedInvestment([]);
    onClearFilter({});
    handleClose();
  };

  const categoryOptionsList = categories.map((item: any) => {
    return (
      <Chip
        sx={{
          border: `1px solid ${
            selectedCategories.includes(item?.name) ? "#0152FB" : "#F5F5F5"
          }`,
          background: `${
            selectedCategories.includes(item?.name) ? "#EFF8FF" : "#FAFAFA"
          }`,
          color: `${
            selectedCategories.includes(item?.name) ? "#0152FB" : "#344054"
          }`,
        }}
        size="small"
        label={item?.name}
        onClick={() => handleOptionClick(item?.name, "CATEGORY_FOCUS")}
      />
    );
  });

  const marketOptionsList = marketPresenceCountries.map((item: any) => {
    return (
      <Chip
        sx={{
          border: `1px solid ${
            selectedMarkets.includes(item?.id) ? "#0152FB" : "#F5F5F5"
          }`,
          background: `${
            selectedMarkets.includes(item?.id) ? "#EFF8FF" : "#FAFAFA"
          }`,
          color: `${
            selectedMarkets.includes(item?.id) ? "#0152FB" : "#344054"
          }`,
        }}
        size="small"
        label={item?.name}
        onClick={() => handleOptionClick(item?.id, "MARKETS")}
      />
    );
  });

  const servicesOptionsList = servicesList.map((item: any) => {
    return (
      <Chip
        sx={{
          border: `1px solid ${
            selectedServices.includes(item?.display_name)
              ? "#0152FB"
              : "#F5F5F5"
          }`,
          background: `${
            selectedServices.includes(item?.display_name)
              ? "#EFF8FF"
              : "#FAFAFA"
          }`,
          color: `${
            selectedServices.includes(item?.display_name)
              ? "#0152FB"
              : "#344054"
          }`,
        }}
        size="small"
        label={item?.display_name}
        onClick={() => handleOptionClick(item?.display_name, "SERVICES")}
      />
    );
  });

  const engagementModelOptionsList = engagementModelList.map((item: any) => {
    return (
      <Chip
        sx={{
          border: `1px solid ${
            selectedEngagementModels.includes(item?.display_name)
              ? "#0152FB"
              : "#F5F5F5"
          }`,
          background: `${
            selectedEngagementModels.includes(item?.display_name)
              ? "#EFF8FF"
              : "#FAFAFA"
          }`,
          color: `${
            selectedEngagementModels.includes(item?.display_name)
              ? "#0152FB"
              : "#344054"
          }`,
        }}
        size="small"
        label={item?.display_name}
        onClick={() =>
          handleOptionClick(item?.display_name, "ENGAGEMENT_MODELS")
        }
      />
    );
  });

  const paymentTermsOptionsList = paymentTermsList.map((item: any) => {
    return (
      <Chip
        sx={{
          border: `1px solid ${
            selectedPaymentTerms.includes(item?.name) ? "#0152FB" : "#F5F5F5"
          }`,
          background: `${
            selectedPaymentTerms.includes(item?.name) ? "#EFF8FF" : "#FAFAFA"
          }`,
          color: `${
            selectedPaymentTerms.includes(item?.name) ? "#0152FB" : "#344054"
          }`,
        }}
        size="small"
        label={item?.name}
        onClick={() => handleOptionClick(item?.name, "PAYMENT_TERMS")}
      />
    );
  });

  const tenureOptionsList = tenureList.map((item: any) => {
    return (
      <Chip
        sx={{
          border: `1px solid ${
            selectedTenure.includes(item?.display_name) ? "#0152FB" : "#F5F5F5"
          }`,
          background: `${
            selectedTenure.includes(item?.display_name) ? "#EFF8FF" : "#FAFAFA"
          }`,
          color: `${
            selectedTenure.includes(item?.display_name) ? "#0152FB" : "#344054"
          }`,
        }}
        size="small"
        label={item?.display_name}
        onClick={() => handleOptionClick(item?.display_name, "TENURE")}
      />
    );
  });

  const exclusivityOptionsList = exclusivityList.map((item: any) => {
    return (
      <Chip
        sx={{
          border: `1px solid ${
            selectedExclusivity.includes(item?.name) ? "#0152FB" : "#F5F5F5"
          }`,
          background: `${
            selectedExclusivity.includes(item?.name) ? "#EFF8FF" : "#FAFAFA"
          }`,
          color: `${
            selectedExclusivity.includes(item?.name) ? "#0152FB" : "#344054"
          }`,
        }}
        size="small"
        label={item?.name}
        onClick={() => handleOptionClick(item?.name, "EXCLUSIVITY")}
      />
    );
  });

  const tradeMarketingOptionsList = investmentsList.map((item: any) => {
    return (
      <Chip
        sx={{
          border: `1px solid ${
            selectedInvestment.includes(item?.name) ? "#0152FB" : "#F5F5F5"
          }`,
          background: `${
            selectedInvestment.includes(item?.name) ? "#EFF8FF" : "#FAFAFA"
          }`,
          color: `${
            selectedInvestment.includes(item?.name) ? "#0152FB" : "#344054"
          }`,
        }}
        size="small"
        label={item?.name}
        onClick={() => handleOptionClick(item?.name, "TRADE_MARKETING")}
      />
    );
  });

  return (
    <React.Fragment>
      <Button onClick={handleClickOpen} className="addfilter">
        Advanced Filters
        <img src="../svgs/filter.svg" alt="searchicon" />
      </Button>
      <Dialog
        className="modal_624"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Filters</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ padding: 0 }}>
          <Box
            sx={{
              flexGrow: 1,
              bgcolor: "background.paper",
              display: "flex",
              borderTop: "1px solid #E4E7EC",
              borderBottom: "1px solid #E4E7EC",
              minHeight: 224,
            }}
          >
            <Tabs
              className="advanced_filter"
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              sx={{
                borderRight: 1,
                borderColor: "divider",
                minWidth: "220px",
              }}
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#1570ef",
                },
              }}
            >
              <Tab
                label="Item One"
                {...a11yProps(0)}
                value={value}
                component={() => (
                  <Button onClick={() => setValue(0)}>
                    Category Focus
                    <Chip
                      sx={{
                        width: "auto",
                        border: "1px solid #F2F4F7",
                        background: "#F9FAFB",
                      }}
                      size="small"
                      label={selectedCategories.length
                        .toString()
                        .padStart(2, "0")}
                    />
                  </Button>
                )}
              />

              <Tab
                label="Market Focus "
                {...a11yProps(1)}
                component={() => (
                  <Button onClick={() => setValue(1)}>
                    Market Focus
                    <Chip
                      sx={{
                        width: "auto",
                        border: "1px solid #F2F4F7",
                        background: "#F9FAFB",
                      }}
                      size="small"
                      label={selectedMarkets.length.toString().padStart(2, "0")}
                    />
                  </Button>
                )}
              />
              <Tab
                label="Service Capabilites"
                {...a11yProps(2)}
                component={() => (
                  <Button onClick={() => setValue(2)}>
                    Service Capabilites
                    <Chip
                      sx={{
                        width: "auto",
                        border: "1px solid #F2F4F7",
                        background: "#F9FAFB",
                      }}
                      size="small"
                      label={selectedServices.length
                        .toString()
                        .padStart(2, "0")}
                    />
                  </Button>
                )}
              />
              <Tab
                label="Market Focus "
                {...a11yProps(3)}
                component={() => (
                  <Button onClick={() => setValue(3)}>
                    {" "}
                    Key Terms{" "}
                    <Chip
                      sx={{
                        width: "auto",
                        border: "1px solid #F2F4F7",
                        background: "#F9FAFB",
                      }}
                      size="small"
                      label={(
                        selectedEngagementModels.length +
                        selectedPaymentTerms.length +
                        selectedExclusivity.length +
                        selectedTenure.length +
                        selectedInvestment.length
                      )
                        .toString()
                        .padStart(2, "0")}
                    />
                  </Button>
                )}
              />
            </Tabs>
            <TabPanel value={value} index={0}>
              <div className="wrap-flex">{categoryOptionsList}</div>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <div className="wrap-flex">{marketOptionsList}</div>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <div className="wrap-flex">{servicesOptionsList}</div>
            </TabPanel>
            <TabPanel value={value} index={3}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  maxWidth: "400px",
                  padding: "0",
                  marginBottom: "8px",
                  marginTop: "-15px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: " #101828",
                    fontWeight: 500,
                    marginBottom: "5px",
                    marginTop: "5px",
                  }}
                >
                  Accepted Business Models
                </Typography>
                <div className="wrap-flex">{engagementModelOptionsList}</div>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: " #101828",
                    fontWeight: 500,
                    marginBottom: "5px",
                    marginTop: "5px",
                  }}
                >
                  Payment Terms
                </Typography>
                <div className="wrap-flex">{paymentTermsOptionsList}</div>
                <Row>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: " #101828",
                      fontWeight: 500,
                      marginBottom: "5px",
                      marginTop: "5px",
                    }}
                  >
                    Exclusivity
                  </Typography>
                  <div className="wrap-flex">{exclusivityOptionsList}</div>
                </Row>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: " #101828",
                    fontWeight: 500,
                    marginBottom: "5px",
                    marginTop: "5px",
                  }}
                >
                  Minimum Exclusivity Tenure
                </Typography>
                <div className="wrap-flex">{tenureOptionsList}</div>
                <Row>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: " #101828",
                      fontWeight: 500,
                      marginBottom: "5px",
                      marginTop: "5px",
                    }}
                  >
                    Preference on Marketing Investment
                  </Typography>
                  <div className="wrap-flex">{tradeMarketingOptionsList}</div>
                </Row>
              </Grid>
            </TabPanel>
          </Box>
        </DialogContent>
        <DialogActions>
          <FooterButton variant="outlined" onClick={handleClearFilter}>
            Clear Filters
          </FooterButton>
          <FooterButton onClick={handleFilter} autoFocus>
            Save
          </FooterButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
